import React from 'react';
import MockTest from '../Mock/DashboardLayout';

function Mock() {
    return <MockTest />;
}

export default Mock;